import React, { useCallback, useMemo } from 'react';
import { LegalIssuesForm } from '../../../../../../components/LoiForm/LegalIssuesForm';
import { LoiForm } from '../../../../../../slices/marketplace/loi-form/loi-form';
import { LoiFormMode } from '../../../../../../slices/marketplace/loi-form/loi-form-mode.enum';
import { LegalIssueItem } from '../../../../../../slices/marketplace/loi-form/legal-issue-item';
import './AdditionalNdaCovenants.scss';

interface AdditionalNdaCovenantsProps {
    formData: LoiForm;
    isReadonly: boolean;
    onChange: (additionalCovenants: LegalIssueItem[]) => void;
    invalidItemIds?: Set<string>;
}

export const AdditionalNdaCovenants = (props: AdditionalNdaCovenantsProps) => {
    const additionalCovenants = props.formData.additionalCovenants ?? [];
    const additionalCovenantSections = useMemo(
        () =>
            (props.formData?.legalIssueSections ?? []).filter((s) =>
                additionalCovenants.some((ac) => ac.sectionId === s.id)
            ),
        [props.formData?.legalIssueSections, additionalCovenants]
    );

    const handleChange = useCallback((payload: LoiForm) => {
        props.onChange(payload.legalIssues ?? []);
    }, [props.onChange]);

    return (
        <div className="additional-nda-covenants-body">
            <LegalIssuesForm
                legalIssueSections={additionalCovenantSections}
                legalIssues={additionalCovenants}
                termForm={props.formData.termForm}
                onChange={handleChange}
                mode={LoiFormMode.BuyerProfile}
                readOnly={props.isReadonly}
                invalidItemIds={props.invalidItemIds}
            />
        </div>
    );
};
